module.exports = __webpack_public_path__ + "img/clear_day.9d31deca.svg";